export default "__VITE_ASSET__CmiRiiZS__"